import './button-history-points.scss'

import { Link } from 'gatsby'
import React from 'react'

import { BoldTextParts } from '../../../../../common/BoldTextParts'

interface ButtonHistoryPointsProps {
  href: string
  text: string
  className?: string
}

export const ButtonHistoryPoints = ({
  href,
  text,
  className = '',
}: ButtonHistoryPointsProps) => {
  if (!text || !href) {
    return null
  }

  return (
    <Link className={`buttonHistoryPoints-infos-button ${className}`} to={href}>
      <BoldTextParts text={text} />
    </Link>
  )
}
